import React, { useState } from 'react';
import PropTypes from 'prop-types';
import searchFilterPropType from '../../../../../../utility/PropTypes/searchFilterPropType';
import BaseFacet from '../../../../../../classes/facets/BaseFacet/BaseFacet';

function FilterModalPatternD({
  facetType,
  facetClass,
  facets,
  addFacet,
  setFacets,
  searchType,
}) {
  const [selectedOperator, setSelectedOperator] = useState(-1);

  const handleSelectOperatorOnChange = (e) => {
    const { value } = e.target;
    setSelectedOperator(value);
    if (facets.length > 0) {
      const updatedOperatorTypeFacets = facets
        .map((facet) => ({ ...facet, operatorId: Number(value) }));
      setFacets(updatedOperatorTypeFacets);
    } else {
      (
        addFacet({
          facetId: facetType.id,
          operatorId: Number(value),
          value1: '1',
          value2: '',
        })
      );
    }
  };

  React.useEffect(() => {
    if (facets.length > 0) {
      setSelectedOperator(facets[0].operatorId);
    }
  }, []);

  /* istanbul ignore next */
  return (
    <div>
      <h6>
        {`${facetClass.getDescription(searchType)}`}
      </h6>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <select
              className="form-control"
              data-testid="operator-combobox"
              onChange={handleSelectOperatorOnChange}
              value={selectedOperator}
            >
              <option value={-1} disabled>-- Select an option --</option>
              {
                  facetClass.getOperatorSelectOptions().map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))
                }
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
FilterModalPatternD.propTypes = {
  facetType: PropTypes.shape({
    id: PropTypes.number,
    validOperators: PropTypes.arrayOf(PropTypes.number),
    displayValue: PropTypes.string,
    modalType: PropTypes.number,
  }).isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape(searchFilterPropType)).isRequired,
  addFacet: PropTypes.func.isRequired,
  facetClass: PropTypes.instanceOf(BaseFacet).isRequired,
  setFacets: PropTypes.func.isRequired,
  searchType: PropTypes.number.isRequired,
};
export default FilterModalPatternD;
